(function () {
    'use strict';
    angular
            .module('imnApp')
            .factory('OltData', OltData);

    OltData.$inject = ['$rootScope'];

    function OltData($rootScope) {

        return {
            arrayOlts: [],
            setArrayOlts: function (list) {
                list.forEach(parseOlt);
                this.arrayOlts = list;
            },
            addOltOnList: function (olt) {
                this.arrayOlts.push(parseOlt(olt));
            },
            removeOlts: function (oltList) {
                var _this = this;
                this.detail = null;
                oltList.forEach(function (selectedOlt) {
                    _this.arrayOlts.forEach(function (olt, index, array) {
                        if (olt.id == selectedOlt.id) {
                            array.splice(index, 1);
                        }
                    });
                });
                $rootScope.$broadcast('oltDelete');
            },
            isSearch: false,
            setSearch: function (isSearch) {
                this.isSearch = isSearch;
                if (isSearch) {
                    $rootScope.$broadcast('oltSearch');
                }
            },
            dataLoaded: false,
            detail: null,
            setDetail: function (detail) {
                this.detail = detail;
                $rootScope.$broadcast('oltDetailLoad');
            },
            triggerItemSelected: function () {
                $rootScope.$broadcast('oltItemSelectedLoad');
            },
            selected: [],
            reset: function () {
                this.arrayOlts = [];
                this.isSearch = false;
                this.dataLoaded = false;
                this.detail = null;
                this.selected = [];
            },
            requestRunning: false
        };

        function parseOlt(item) {

            if (item.mostCriticalAlarm == 'NONE' && item.onLine) {
                item.mostCriticalAlarm = 'online'
            } else if (!item.onLine) {
                item.mostCriticalAlarm = 'offline'
            }

            item.mostCriticalAlarm = item.mostCriticalAlarm.toLowerCase();
            return item;
        }

    }
})();